// @ts-ignore
import logo from "../../images/logo-dark.png";
import { Link } from "react-router-dom";

type Props = {
  image?: string;
};

function Logo({ image = logo }: Props) {
  return (
    <div className="">
      <Link to="/">
        <img
          src={image}
          className="m-auto h-5 w-auto sm:h-8"
          style={{ maxWidth: "unset" }}
        />
      </Link>
    </div>
  );
}

export default Logo;
